
//http://vriendschap.local/wp-json/wp/v2/users/me
//https://devtrium.com/posts/how-use-react-context-pro
import React, { useContext, useState, useEffect, useRef } from 'react';
import { debugdiv, useMountEffect} from './ODevice';
import ErrorBoundary from './ErrorBoundary';

import ODevice from './ODevice';
import SinusDemo2 from './SinusDemo2';
import { ReadingsContext } from './ODevice';
import WordpressAPI from './WordPressAPI';
import DisplayData from './DisplayData';
import Graph from './Graph';

function App() {
  /*
  * Generic 
  */
  const [debugvisible, setDebugvisible] = useState(true);
  const functionname ='App';
  const refDebugDiv = useRef();
  
  /*
  * defenitions used in this function
  */
  var readings = useContext(ReadingsContext);

  /*
  * handles used in this function function  
  */

    // Only run once while after mounting
    // Used to set default values
    useMountEffect(()=>{
      console.log( functionname  + '  is loaded');
      if (debugvisible) {
        refDebugDiv.current.style.display = 'unset';
      } else {
        refDebugDiv.current.style.display = 'none';
      }
  });

  const handleChangeChkDebug = event =>{
    if (event.target.checked) {
        console.log('✅ Checkbox is checked');
        refDebugDiv.current.style.display = 'unset';
      } else {
        console.log('⛔️ Checkbox is NOT checked');
        refDebugDiv.current.style.display = 'none';
      }
      setDebugvisible(debugvisible => !debugvisible);
    };
  
  //Local functions
  const [milliseconds, setMilliSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMilliSeconds(milliseconds => milliseconds + 1);        
    }, 1);
    return () => clearInterval(interval);
  }, [readings]);


  return (

    <div className="App" style={debugdiv} >
     
      <ErrorBoundary>
      
          <ODevice>
          <SinusDemo2></SinusDemo2>
          
            <div>
                <div  style={debugdiv}>
                <input type="checkbox" defaultChecked={debugvisible} onChange={ handleChangeChkDebug } />&nbsp;                             
                    <b>The {functionname }  Frame</b> 
                </div>
                <div ref={refDebugDiv} >
                  <div>milliseconds { milliseconds} </div>                  
                  <div>last reading milliseconds: { readings.lastReading.milliseconds }</div>
                  <div>last reading stream 1: { readings.lastReading.stream_1 }</div>
                  <div>last reading stream 2: { readings.lastReading.stream_2 }</div>
                </div>
            </div>
            
            <WordpressAPI></WordpressAPI>
            <DisplayData></DisplayData>
            <Graph></Graph>
          </ODevice>
        

      </ErrorBoundary>
    </div>
  );
}


export default App;
